import axios from 'axios';
import { deepHashSnakeCase, deepHashCamelCase } from './convert-keys';
import eventBus from './event-bus';

const httpClient = axios.create({
  transformRequest: [(data => (data ? deepHashSnakeCase(data) : undefined)), ...axios.defaults.transformRequest],
  transformResponse: [...axios.defaults.transformResponse, deepHashCamelCase],
});

httpClient.interceptors.response.use(response => response, (error) => {
  if (error.response.status >= 500) {
    eventBus.emit('server-error', {});
  }

  if (error.response.status === 401) {
    eventBus.emit('unauthorized-error', {});
  }

  if (error.response.status === 403) {
    eventBus.emit('forbidden-error', error.response.data);
  }

  if (error.response.status === 404 && error.response.data.error === 'NotFoundError') {
    eventBus.emit('not-found-error', {});
  }

  return Promise.reject(error.response.data);
});

const csrf = document.querySelector('meta[name="csrf-token"]');
if (csrf) {
  httpClient.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN': csrf.getAttribute('content'),
  };
}

export default httpClient;
